// Monthly session fetches only need enough per day to detect availability and show a
// representative session, never a full per-day list. Cap the payload server-side (see the
// v1/listings/:id/sessions maxSessionsPerDay param). Kept above the client-side
// booked/overlapped filters so a day whose earliest sessions are unavailable still surfaces
// its remaining open ones.
export const MAX_SESSIONS_PER_DAY_FOR_AVAILABILITY = 5;
